import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faUsers, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { getExperienceIcon } from './ExperienceTimelineCard';

export default function PastExperiencesSection({ experiences }) {
  // experiences is already grouped by month: { "January 2026": [...], "December 2025": [...] }
  const months = Object.keys(experiences).reverse(); // Most recent first

  return (
    <div className="space-y-8">
      {months.map(month => (
        <div key={month}>
          <h3 className="text-lg md:text-xl font-bold text-text-secondary mb-4 flex items-center gap-2">
            <FontAwesomeIcon icon={faBook} className="text-xl text-text-secondary" />
            {month}
          </h3>
          
          {/* Desktop: Grid */}
          <div className="hidden md:grid grid-cols-3 gap-4">
            {experiences[month].map(exp => (
              <PastExperienceCard key={exp.id} experience={exp} />
            ))}
          </div>

          {/* Mobile: Stack */}
          <div className="md:hidden space-y-3">
            {experiences[month].map(exp => (
              <PastExperienceCard key={exp.id} experience={exp} mobile={true} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function PastExperienceCard({ experience, mobile = false }) {
  const navigate = useNavigate();
  const expDate = experience.date?.toDate ? experience.date.toDate() : (experience.date ? new Date(experience.date) : null);
  const IconComponent = getExperienceIcon(experience.type);

  return (
    <motion.div
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => navigate(`/experience/${experience.id}`)}
      className="bg-white rounded-xl border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-all opacity-75 hover:opacity-100 touch-target"
    >
      <div className="flex items-center gap-3 mb-3">
        <div className="text-2xl md:text-3xl text-primary opacity-60">
          <FontAwesomeIcon icon={IconComponent} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="font-serif font-bold text-base text-text-primary line-clamp-1">
            {experience.title}
          </h4>
          <p className="text-xs text-text-secondary">
            {expDate ? format(expDate, 'MMM d, yyyy') : 'Date TBD'}
          </p>
        </div>
      </div>

      {experience.guests && (
        <div className="text-xs text-text-secondary flex items-center gap-1 mb-3">
          <FontAwesomeIcon icon={faUsers} className="w-3 h-3" />
          {experience.guests} guests
        </div>
      )}

      <div className="mt-3 pt-3 border-t border-gray-200">
        <span className="text-xs font-semibold text-gray-500 flex items-center gap-1">
          View memory
          <FontAwesomeIcon icon={faChevronRight} className="w-3 h-3" />
        </span>
      </div>
    </motion.div>
  );
}

